import type { GameState } from './types'

/**
 * ใครเพิ่งซื้อของในสเต็ปนี้บ้าง
 *
 * มีไว้เพราะ "เงินลด" อย่างเดียวบอกไม่ได้ว่าดีหรือร้าย — ซื้อโฉนดกับโดนรีดค่าเช่า
 * เงินลดเหมือนกันทั้งคู่ แต่คนละอารมณ์คนละท่าคนละเสียง ต้องดูที่ผลลัพธ์ว่าได้อะไรมา
 *
 * ใช้ร่วมกันทั้งท่าทางตัวละคร (world.ts) และเสียงพูด (useGameSfx.ts)
 * จะได้ไม่มีวันขัดกันเอง — ท่าดีใจแต่เสียงเศร้า
 *
 * คืนเป็นชุดของ player.id (ไม่ใช่ลำดับใน array)
 */
export function purchasers(before: GameState, after: GameState): Set<number> {
  const out = new Set<number>()

  after.tiles.forEach((t, id) => {
    const b = before.tiles[id]
    if (!b || t.ownerId === null) return
    // เพิ่งได้เป็นเจ้าของ หรืออัปเกรดของเดิม
    if (t.ownerId !== b.ownerId || t.level > b.level) out.add(t.ownerId)
  })

  after.players.forEach((p, i) => {
    const b = before.players[i]
    if (b && p.assets.length > b.assets.length) out.add(p.id)
  })

  return out
}
